import React, { Component } from "react";
import {
  StyledAnimationTimeContainer,
  StyledAppliedAnimationsListContainer,
  StyledLayerHeaderAndAnimationContainer,
  StyledLayerImageIcon,
  StyledLayerItem,
  StyledLayerItemColumn,
  StyledLayerItemDescription,
  StyledLayerItemIcon,
  StyledLayerSVGIcon,
} from "../../../styled/details/styleSlideLayers";
import { ReactComponent as TextNormal } from "../../../../assets/icons/text-normal.svg";
import { getMIMETypeFromFabricObject, isURL } from "../../../../_utils/common";
import { Box, Icon, Tooltip } from "@chakra-ui/react";
import { FaEye, FaEyeSlash, FaLock, FaGripVertical } from "react-icons/fa";
import { withTranslation } from "react-i18next";

const LayerImageIcon = ({ mime, layer, name }) => {
  let url;
  let alt;
  if (mime === "image") {
    url = layer.src;
  } else if (mime === "giphy") {
    url = layer.src;
    alt = name;
  } else if (mime === "video") {
    url = layer.cover;
  } else if (mime === "shape") {
    if (isURL(layer.svg)) {
      return (
        <StyledLayerImageIcon
          src={layer.svg}
          alt="layer-image-icon"
        ></StyledLayerImageIcon>
      );
    }
    return <StyledLayerSVGIcon src={layer.svg} />;
  }

  return <StyledLayerImageIcon src={url} alt={alt}></StyledLayerImageIcon>;
};

const LayerTextIcon = () => {
  return <TextNormal />;
};

class SlideLayerItem extends Component {
  render() {
    const { t } = this.props;
    const { layer, location, isActive, layerTitle, isSorting } = this.props;
    const mime = getMIMETypeFromFabricObject(layer.type);

    const locked = !layer.selectable && layer.selectable === false;
    const isVisible = layer.visible;

    return (
      <>
        <StyledLayerItem
          onClick={this.selectElement}
          className={isActive}
          isSorting={isSorting}
        >
          <Icon as={FaGripVertical} mr={3} color="#888888" />
          <StyledLayerItemIcon>
            {mime !== "text" ? (
              <LayerImageIcon layer={layer} mime={mime} />
            ) : (
              <LayerTextIcon />
            )}
          </StyledLayerItemIcon>

          {location === "edit" ? (
            <StyledLayerItemColumn>
              <StyledLayerItemDescription location={location}>
                {mime === "text"
                  ? layer.text
                  : `${mime[0].toUpperCase()}${mime.slice(1)}`}
              </StyledLayerItemDescription>
              <p className="layer-title">{layerTitle}</p>
            </StyledLayerItemColumn>
          ) : (
            <StyledLayerHeaderAndAnimationContainer>
              <StyledLayerItemDescription location={location}>
                {mime === "text"
                  ? layer.text
                  : `${mime[0].toUpperCase()}${mime.slice(1)}`}
              </StyledLayerItemDescription>
              <StyledAppliedAnimationsListContainer>
                {/* {listOfAnimations} */}
              </StyledAppliedAnimationsListContainer>
            </StyledLayerHeaderAndAnimationContainer>
          )}

          {locked ? (
            <Tooltip
              hasArrow
              placement="bottom"
              label={t("slidelayer.unlock_layer")}
              shouldWrapChildren
            >
              <Icon as={FaLock} mr={3} />
            </Tooltip>
          ) : location === "edit" ? (
            <>
              <Box mr={4}>
                <Tooltip
                  hasArrow
                  placement="bottom"
                  label={
                    isVisible ? t("slidelayer.hide") : t("slidelayer.show")
                  }
                  shouldWrapChildren
                >
                  {isVisible ? (
                    <FaEye onClick={(e) => this.toggleVisibility(e)} />
                  ) : (
                    <FaEyeSlash onClick={(e) => this.toggleVisibility(e)} />
                  )}
                </Tooltip>
              </Box>
            </>
          ) : (
            <StyledAnimationTimeContainer>
              {/* {totalLayerAnimationTime} */}
            </StyledAnimationTimeContainer>
          )}
        </StyledLayerItem>
      </>
    );
  }

  selectElement = () => {
    const { layer } = this.props;
    let locked = !layer.selectable && layer.selectable === false;
    if (!locked) {
      this.props.onSelect(layer.id, "select");
    } else {
      this.props.onSelect(layer.id, "unlock");
    }
  };

  toggleVisibility = (e) => {
    e.stopPropagation();
    const { layer } = this.props;
    const isVisible = layer.visible;

    if (this.props.onToggleVisibility) {
      this.props.onToggleVisibility(layer.id, !isVisible);
    }
  };
}

export default withTranslation(["workspace"])(SlideLayerItem);
